import React from 'react';
import Skeleton from 'react-loading-skeleton';

import 'react-loading-skeleton/dist/skeleton.css';

export default function LoadingPageSkeleton() {
  return (
    <section className="skeleton-loading-page">
      <Skeleton className="horizontal-row" />
      <section>
        <Skeleton className="long-vertical-row" />
        <section>
          <Skeleton className="horizontal-row" />
          <Skeleton className="long-vertical-row" />
        </section>
      </section>
    </section>
  );
}
